import { useContext, useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { AuthContext } from '../../contexts/AuthContext'

import { Footer, Wrapper } from 'components'
import { useNavigate } from 'react-router-dom'
import { Button, Card, Input, toast } from 'keep-react'
import { authService } from 'api/services/auth'

const validationSchema = Yup.object().shape({
  username: Yup.string().email().required('Email é obrigatório'),
})

export const TwoFA = () => {
  const { show2FAScreen, setShow2FAScreen, currentUser, setIsSignedIn } =
    useContext(AuthContext)
  const [isLoggingIn, setIsLoggingIn] = useState<boolean>(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (!show2FAScreen) {
      navigate('/login')
    }

    const send2FACode = async () => {
      try {
        await authService.sendMFACode({
          username: currentUser?.Email || '',
        })
      } catch (err) {
        toast.error('Erro ao enviar código de autenticação de dois fatores.')
      }
    }

    send2FACode()
  }, [show2FAScreen, navigate])

  const formik = useFormik({
    initialValues: { username: currentUser?.Email || '', code: '' },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema,
    onSubmit: async values => {
      setIsLoggingIn(true)
      try {
        await authService.validateMFACode({
          username: currentUser?.Email || '',
          mfaCode: Number(values.code),
        })

        setShow2FAScreen && setShow2FAScreen(false)
        setIsSignedIn && setIsSignedIn(true)
        navigate('/dashboard')
      } catch (err) {
        toast.error('Erro ao iniciar sessão.')
      } finally {
        setIsLoggingIn(false)
      }
    },
  })

  return (
    <div
      className="w-screen h-screen bg-cover bg-no-repeat bg-center flex items-center"
      style={{
        backgroundImage: `url(images/dark_broker.jpg)`,
      }}
    >
      <Wrapper>
        <div className="flex flex-col items-center m-auto gap-x-4 gap-y-12 max-w-[700px] h-full">
          <h1 className="text-white uppercase font-semibold text-2xl text-center tracking-wider">
            Seguros à velocidade de um foguetão
          </h1>
          <div className="grid grid-cols-2 gap-12 items-center w-full">
            <div className="flex flex-col gap-6">
              <Card className="w-full bg-white/70 p-4 rounded-xl max-w-none">
                <h2 className="font-light text-lg text-primary-400 pb-4 uppercase">
                  2 Factor Authentication
                </h2>
                <p className="text-metal-600 text-sm pb-2">
                  Verifique o seu email e insira o código de autenticação de
                  dois fatores.
                </p>
                <form onSubmit={formik.handleSubmit}>
                  <div className="pb-5">
                    <Input
                      type="text"
                      name="code"
                      onChange={formik.handleChange}
                      placeholder="Código de autenticação"
                      className="px-2"
                    />
                  </div>

                  <Button
                    className="w-full"
                    type="submit"
                    disabled={isLoggingIn}
                  >
                    Entrar
                  </Button>
                </form>
              </Card>
            </div>

            <div className="flex flex-col gap-4 items-center justify-center">
              <img
                src="/images/rocket.svg"
                alt="Innovarisk"
                className="max-w-[220px] animate-slideInFade"
              />
              <h2 className="text-white font-roboto mb-[50px] mt-[50px] text-lg text-center">
                A solução que permite de forma simples e fácil aceder aos
                produtos especializados para nichos de mercado.{' '}
              </h2>
            </div>
          </div>
        </div>
      </Wrapper>
      <Footer />
    </div>
  )
}
